import * as runtime from "@baseline/runtime";
import React, { FC } from "react";


namespace ContextMethods
{
    export function bind<T, C extends runtime.Context>(component: FC<T>, context: C): FC<T>
    {

        return (
            (props) =>
                React.createElement(
                    ref.Provider,
                    { value: context },
                    React.createElement(
                        component,
                        props
                    )
                )
        );
    }


    export const ref = React.createContext<runtime.Context>(null);


    export const Provider = ref.Provider;
}


export const Context = Object.assign({}, runtime.Context, ContextMethods);

